import { render, staticRenderFns } from "./GatDialog.vue?vue&type=template&id=19994d25&scoped=true&"
import script from "./GatDialog.vue?vue&type=script&lang=js&"
export * from "./GatDialog.vue?vue&type=script&lang=js&"
import style0 from "./GatDialog.vue?vue&type=style&index=0&id=19994d25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19994d25",
  null
  
)

export default component.exports